import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SpProjectListComponent } from './sp-project-list/sp-project-list.component';
import { ROUTE_PATHS } from '../../constants/route-paths';

const spProjectRoutes: Routes = [
  {
    path: ROUTE_PATHS.PROJECTS,
    children: [
      {
        path: '',
        redirectTo: 'list',
        pathMatch: 'full'
      },
      {
        path: 'create',
        loadChildren: () => import('./sp-project-create/sp-project-create.module').then(m => m.SpProjectCreateModule)
      },
      {
        path: 'details',
        redirectTo: 'list',
        pathMatch: 'full'
      },
      {
        path: ROUTE_PATHS.PROJECT_DETAILS,
        loadChildren: () => import('./sp-project-details/sp-project-details.module').then(m => m.SpProjectDetailsModule)
      },
      {
        path: 'list',
        component: SpProjectListComponent
      }
    ]
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(spProjectRoutes)
  ],
  exports: [
    RouterModule
  ]
})
export class SpProjectRoutingModule {}
